<template>
  <div class="what-need-to-pickup py20">
    <div class="row" v-if="isActive || isFilled">
      <div class="col-xs-12 col-sm-12 col-md-12">
        <div class="row">
          <div class="col-xs-2 col-sm-2 col-md-1">
            <div
              class="number-circle lh35 cl-white brdr-circle align-center weight-700"
              :class="{ 'bg-cl-th-accent' : isActive || isFilled, 'bg-cl-tertiary' : !isFilled && !isActive }"
            >
              1
            </div>
          </div>
          <div class="col-xs-8 col-sm-8 col-md-10">
            <div class="row">
              <div class="col-xs-12" :class="{ 'cl-bg-tertiary' : !isFilled && !isActive }">
                <h3 class="m0">
                  {{ $t('What need to pickup') }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-1 end-xs flex">
            <i data-v-0c2f6ec6="" class="material-icons arrow-i"
               :class="{ 'active' : isActive }"
            >keyboard_arrow_right</i>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt15"  v-if="isActive">
      <div class="col-xs-12">
        <div class="row">
          <div class="textarea-box textarea-wrapper col-xs-12 start-xs">
            <textarea
              rows="4"
              cols="10"
              class="textarea-custom"
              v-model="pickupTarget"
              maxlength="10000"
              data-hj-whitelist
              :placeholder="$t('Describe your wishes')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt15" v-if="isActive && isCheckoutAllowed">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 col-md-7 button-container" style="margin: auto">
            <button-full
              data-testid="deliveryTimeSubmit"
              @click.native="sendDataToCheckout"
              :disabled="!pickupTarget"
            >
              {{ $t('Continue to personal details') }}

            </button-full>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt15" v-if="!isActive && isFilled">
      <div class="col-xs-12">
        <div class="row fs16 brdr-bottom-1 brdr-cl-bg-secondary">
          <div class="col-xs-12">
            <div class="lh30 flex end-xs" v-if="isFilled && !isActive">
              <a href="#" class="cl-tertiary flex" @click.prevent="edit">
                <span class="pr5 h6">
                  {{ $t('Edit') }}
                </span>
                <i class="material-icons cl-tertiary">edit</i>
              </a>
            </div>
          </div>
          <div class="h4 col-xs-12 h4 mb15 bg-cl-secondary" data-testid="pickupTargetSummary">
            <p class="pre-line">
              {{ pickupTarget }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import BaseCheckbox from 'theme/components/core/blocks/Form/BaseCheckbox'
  import BaseInput from 'theme/components/core/blocks/Form/BaseInput'
  import ButtonFull from 'theme/components/theme/ButtonFull'
  import Tooltip from 'theme/components/core/Tooltip'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      ButtonFull,
      Tooltip,
      BaseCheckbox,
      BaseInput
    },
    props: {
      isActive: {
        type: Boolean,
        required: true
      }
    },
    watch: {
      pickupTarget: {
        deep: true,
        handler: function () {
          this.saveComment()
        }
      }
    },
    data () {
      return {
        isFilled: false,
        pickupTarget: '',
        comments: []
      }
    },
    mounted () {
      this.comments = JSON.parse(localStorage.getItem('shop/anywhere/comment'));
      if (this.comments && this.comments.length) {
        this.comments.map(comment => {
          if(comment.location === this.currentLocation.code) {
            this.pickupTarget = comment.comment
          }
        })
        if (!this.pickupTarget) {
          this.formArrayComments()
        }
      } else {
        this.comments = []
        this.formArrayComments()
      }
    },
    computed: {
      ...mapGetters({
        currentLocation: 'locations/getActiveLocation'
      }),
      isCheckoutAllowed () {
        return (this.currentLocation.hasOwnProperty('is_checkout_allowed')) ? this.currentLocation.is_checkout_allowed : true
      },
    },
    methods: {
      edit () {
        if (this.isFilled) {
          this.$bus.$emit('pickup-checkout-before-edit', 'whatNeedToPickup')
        }
      },
      sendDataToCheckout () {
        this.$bus.$emit('pickup-checkout-after-whatNeedToPickup', this.pickupTarget, !!this.pickupTarget.trim().length)
        this.isFilled = true
      },
      saveComment () {
        this.comments.map(comment => {
          if (comment.location === this.currentLocation.code) {
            comment.comment = this.pickupTarget;
          }
        })
        localStorage.setItem('shop/anywhere/comment', JSON.stringify(this.comments));
      },
      formArrayComments () {
        this.comments.push({
          location: this.currentLocation.code,
          comment: ''
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  ::placeholder {
    color: #bdbdbd;
  }
  .counter {
    margin-left: 2px;
  }
  .pre-line {
    white-space: pre-line;
    margin-top: -1em;
    word-wrap: break-word;
    word-break: break-word;
  }
  .textarea-custom {
    width: calc(100% - 16px);
    height: 90px;
    min-height: 90px;
    max-height: 500px;
    resize: vertical;
    overflow: auto;
    border: 1px solid #111;
    font-family: 'TTNorms Regular', sans-serif;
    padding: 5px;
    font-size: 16px;
  }
</style>
